import getParent from "@/utils/getParent";
import reporter from "../report/reporter";
import { getPage } from "../shared/global";
import { getAttribute } from "./get";

function getTrackerData(targetNode, trackData) {
  const page = getPage();
  const { page_nm, sub_page_nm } = page;
  var source = getAttribute(targetNode, "data-content-source");
  if (source) {
    trackData.source = `${page_nm}_${sub_page_nm || ""}_${source}`;
  } else {
    trackData.source = sub_page_nm ? `${page_nm}_${sub_page_nm}` : page_nm;
  }

  const good_second_type = getAttribute(targetNode, "data-good-second-type");
  if (good_second_type) {
    trackData.good_second_type = good_second_type;
  }

  const good_version = getAttribute(targetNode, "data-good-version");
  if (good_version) {
    trackData.good_version = good_version;
  }
  const source_location = getAttribute(targetNode, "data-source-location");
  if (source_location) {
    trackData.source_location = source_location;
  }

  if (page.page_nm === "采集详情页") {
    const pinDetailDom = document.getElementById("pin_detail");
    if (pinDetailDom) {
      Object.assign(trackData, {
        source_content_id: getAttribute(pinDetailDom, "data-material-id"),
        source_pin_id: getAttribute(pinDetailDom, "data-content-id"),
        source_file_id: getAttribute(pinDetailDom, "data-file-id"),
      });
    }
  }

  trackData.sku = getAttribute(targetNode, "data-sku")?.split(",");
  trackData.sku_ids = getAttribute(targetNode, "data-sku-ids")?.split(",");

  const couponName = getAttribute(targetNode, "data-coupon-nm");
  if (couponName) {
    trackData.coupon_name = couponName;
    trackData.coupon_id = getAttribute(targetNode, "data-coupon-id");
  }

  if (getAttribute(targetNode, "data-iscopyright")) {
    trackData.is_copyright_material = 1;
  }

  return trackData;
}

export function pay_expose(targetNode) {
  const page = getPage();
  const trackData = {
    event_id: 32001,
    event_name: "order_pay_expose",
    order_type: getAttribute(targetNode, "data-order-type"),
    ...page,
  };

  const node = getParent(targetNode, "[data-search-word]");
  if (node) {
    trackData.search_word = getAttribute(node, "data-search-word");
  }

  getTrackerData(targetNode, trackData);

  reporter(trackData);
}

/**
 *
 * @param {HTMLElement} targetNode
 * @param {{
 *  action_type: "订单生成"|"订单支付", order_no, sku, pay_amount, payment_type: "扫码支付"|"对公转账"
 * }} otherData
 */
export function pay_action(targetNode, otherData) {
  try {
    const page = getPage();
    const trackData = {
      event_id: 32002,
      event_name: "order_pay_action",
      order_type: getAttribute(targetNode, "data-order-type"),
      status: 1,
      ...otherData,
      ...page,
    };

    const node = getParent(targetNode, "[data-search-word]");
    if (node) {
      trackData.search_word = getAttribute(node, "data-search-word");
    }

    getTrackerData(targetNode, trackData);

    reporter(trackData);
  } catch (error) {
    console.error(error);
  }
}
